<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="mx-0" :fluid="true">
    <v-row>
      <v-col cols="8" style="font-size: 14px">
        <span class="font-weight-light">Manage Do Not Call List</span><br />
        <span class="font-weight-light"
          >This page displays Phone or Email of customers that do not want to be
          contacted</span
        >
      </v-col>
      <v-spacer />
      <v-col cols="2">
        <div class="text-right">
          <v-btn @click="addToDNC()" color="btncolor" size="large" rounded="xl">
            <v-icon class="mr-2">fa-solid fa-plus</v-icon>
            New DNC
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-switch
          v-model="showInboundBlocked"
          color="primary"
          label="Show Only Inbound Blocked"
          @change="loadDNC"
        ></v-switch>
      </v-col>
      <v-spacer />
      <v-col cols="4">
        <v-text-field
          v-model="search"
          label="Search"
          variant="underlined"
          class="search-text-field"
          append-inner-icon="fa-solid fa-magnifying-glass"
          hide-details
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <data-table-pagination
          rows-type="dnc"
          :pagination="pagination"
          :totalItems="totalDNC"
          :rows-per-page-items="rowsPerPageItems"
        />
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="py-0">
        <v-data-table-server
          style="width: 100%"
          :headers="headers"
          :loading="dncLoading"
          :items="dncTableData"
          :items-length="totalDNC"
          :mobile="false"
          return-object
        >
          <template #item="props">
            <d-n-c-list-row :contact.sync="props.item" />
          </template>

          <!-- remove bottom pagination -->
          <template #bottom></template>
        </v-data-table-server>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="py-0">
        <data-table-pagination
          rows-type="dnc"
          :pagination="pagination"
          :totalItems="totalDNC"
          :rows-per-page-items="rowsPerPageItems"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-right">
        <v-btn @click="addToDNC()" color="btncolor" size="large" rounded="xl">
          <v-icon class="mr-2">fa-solid fa-plus</v-icon>
          New DNC
        </v-btn>
      </v-col>
    </v-row>

    <DNCAddContact
      :dialog="dncAddContactDialog"
      @close="closeDNCAddContact"
      @added="addedDNCContact"
    />

    <!--    <component-->
    <!--      :is="dncAddContactComponent"-->
    <!--      :dialog="dncAddContactDialog"-->
    <!--      @close="closeDNCAddContact"-->
    <!--      @added="addedDNCContact"-->
    <!--    />-->

    <v-snackbar v-model="alert" color="error" :timeout="5000" multi-line bottom>
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { useEventBus } from "@/event-bus/bus";
import C from "@/utils/constants";
import api from "@/services/api.js";
import useAuthMixin from "@/mixins/auth.js";
import useFormatters from "@/mixins/formatters.js";
import DataTablePagination from "@/components/console/partials/DataTablePagination";
import DNCListRow from "@/components/console/dnc/DNCListRow";
import { defineAsyncComponent } from "vue";

export default {
  props: {},
  components: {
    DNCListRow,
    DataTablePagination,
    DNCAddContact: defineAsyncComponent(
      () => import("@/components/console/dnc/DNCAddContact"),
    ),
  },
  data() {
    return {
      text: "Whoops, Something went wrong. Try again.",
      alert: false,
      headers: [
        { title: "Type", align: "start", value: "type", sortable: false },
        {
          title: "Phone/Email",
          align: "start",
          value: "phoneEmail",
          width: "10%",
          sortable: false,
        },
        {
          title: "Channel",
          align: "start",
          value: "channel",
          width: "12%",
          sortable: false,
        },
        {
          title: "Disposition",
          align: "start",
          value: "disposition",
          width: "15%",
          sortable: false,
        },
        {
          title: "Inbound Blocked",
          align: "start",
          value: "inbound_blocked",
          width: "15%",
          sortable: false,
        },
        {
          title: "Date Received",
          align: "start",
          value: "date_received",
          width: "15%",
          sortable: false,
        },
        {
          title: "Actions",
          align: "center",
          value: "actions",
          width: "5%",
          sortable: false,
        },
      ],
      search: "",
      pagination: {
        page: 1,
        rowsPerPage: 40,
        descending: false,
        sortBy: "name",
        totalItems: 0,
      },
      totalDNC: 0,
      rowsPerPageItems: [10, 20, 40],
      dncList: {}, // data map by brokerage id for reference
      dncTableData: [], // array of data cleaned for the table
      dncLoading: false,
      dncAddContactDialog: false,
      // dncAddContactComponent: null,
      showInboundBlocked: false,
    };
  },
  computed: {
    ...mapGetters("user", [
      "responsive",
      "mobileBrokerSort",
      "mobileBrokerSearch",
    ]),
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.loadDNC();
      },
    },
    // mobileBrokerSort(val) {
    //   this.pagination.descending = val;
    // },
    search() {
      console.log("search changed....");
      if (this.search.length > 0) {
        // this is a workaround for a pagination/searching bug
        this.pagination.page = 1;
      }
      this.loadDNC();
    },
  },
  methods: {
    ...useAuthMixin(),
    ...useFormatters(),
    async loadDNC() {
      this.dncLoading = true;

      let index = this.pagination.page - 1;

      let params = {
        pageIndex: index,
        pageSize: this.pagination.rowsPerPage,
        // sort: "created:DESC",
      };

      // only include value param if searching
      if (this.search.length > 0) {
        params["value"] = this.search;
      }

      if (this.showInboundBlocked === true) {
        params["blocked"] = true;
      }
      try {
        let { resp, value } = await api.dnc.search(params);
        console.log("===========================");
        console.log(resp);
        console.log("===========================");
        if (this.search === value) {
          if (resp.data) {
            this.parseDNCData(resp.data);
          }
        }
      } catch (e) {
        this.errorCheck(e);
      } finally {
        this.dncLoading = false;
      }
    },
    parseDNCData(data) {
      if (data.totalElements) {
        this.totalDNC = data.totalElements;
      }

      if (data.content !== null && data.content !== undefined) {
        let content = data.content;
        this.dncList = {};
        this.dncTableData = [];

        for (let i = 0; i < content.length; i++) {
          let dncData = content[i];
          this.dncList[dncData.id] = dncData;

          let dnc = {
            id: "",
            icon: "",
            type: "",
            phoneEmail: "-",
            phoneNumber: "",
            color: "error",
            channel: "-",
            disposition: "-",
            dateReceived: "-",
            blocked: false,
          };
          if (dncData.blocked) {
            dnc.blocked = dncData.blocked;
          }
          if (dncData.id) {
            dnc.id = dncData.id;
          }

          if (dncData.type) {
            dnc.type = this.prettyPrintEnum(dncData.type);
            dnc.icon =
              dncData.type === "EMAIL" ? "fas fa-envelope" : "fas fa-phone";
          }

          if (dncData.value) {
            dnc.phoneEmail =
              dncData.type === "PHONE"
                ? this.formatPhoneNumber(dncData.value)
                : dncData.value;
            if (dncData.type === "PHONE") {
              dnc.phoneNumber = dncData.value;
            }
          }

          if (dncData.channel) {
            dnc.channel = this.prettyPrintEnum(dncData.channel);
          }

          if (dncData.disposition) {
            dnc.disposition = this.prettyPrintEnum(dncData.disposition);
          }

          if (dncData.created) {
            dnc.dateReceived = `${this.formatDate(
              dncData.created,
            )}<br />${this.formatTime(dncData.created)}`;
          }

          this.dncTableData.push(dnc);
        }
      }

      this.dncLoading = false;
    },
    addToDNC() {
      console.log("addToDNC");
      // this.dncAddContactComponent = () => import("./DNCAddContact");
      this.dncAddContactDialog = true;
    },
    closeDNCAddContact() {
      this.dncAddContactDialog = false;
      // this.dncAddContactComponent = null;
    },
    addedDNCContact() {
      console.log("addedDNCContact");
      this.loadDNC();
      this.dncAddContactDialog = false;
      // this.dncAddContactComponent = null;
    },
  },
  mounted() {
    this.loadDNC();

    const _eventBus = useEventBus();
    _eventBus.$on(C.EVENT_BUS.RELOAD_DNC_LIST, this.loadDNC);
  },
  beforeUnmount() {
    const _eventBus = useEventBus();
    _eventBus.$off(C.EVENT_BUS.RELOAD_DNC_LIST, this.loadDNC);
  },
};
</script>

<style scoped>
.v-data-table {
  background: transparent;
}
.v-data-table :deep(.v-data-table-header__sort-icon) {
  font-size: unset;
  margin-left: 4px;
}
.v-data-table :deep(tbody) {
  background: white !important;
  box-shadow:
    0 0 0 -1px rgba(0, 0, 0, 0.2),
    0 0 0 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;
}
.v-data-table :deep(.v-data-table-header__content) {
  font-weight: 400;
}
.v-data-table :deep(tbody tr:hover) {
  background-color: #f4f4f4;
}

.search-text-field :deep(.v-field__append-inner) {
  padding-right: 8px;
}
.search-text-field :deep(.v-field__append-inner .v-icon) {
  font-size: 20px;
}
</style>
